// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-container[data-v-3adfc218] {\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 0px 4px 40px 0px rgba(204, 213, 212, 0.3);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
